export default __webpack_public_path__ + "static/media/UI-UX.b2732bc2.png";